import React, { AnchorHTMLAttributes, PureComponent } from 'react';
import { TTrackData } from '../types/state.d';
import analytics from './analytics';

export interface ITrackLink extends AnchorHTMLAttributes<any> {
  trackingData: TTrackData;
}

class TrackLink extends PureComponent<ITrackLink> {
  trackClick = () => {
    const { trackingData } = this.props;
    analytics.track({
      ...trackingData,
      event: 'click',
      action_name: 'click',
    });
  };

  render() {
    const { trackingData, ...props } = this.props;
    return (
      <a onClick={this.trackClick} href={this.props.href} {...props}>
        {this.props.children}
      </a>
    );
  }
}

export default TrackLink;
